module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio form-inline"
  }, [_vm._l((_vm.radios), function(radio, index) {
    return _c('div', [_c('label', {
      staticStyle: {
        "padding-right": "10px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedItem),
        expression: "selectedItem"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ((index == 0) ? 'required' : ''),
        expression: "(index == 0) ? 'required': ''"
      }],
      attrs: {
        "type": "radio",
        "name": _vm.name,
        "id": _vm.name + '_' + index,
        "disabled": radio.disabled === true
      },
      domProps: {
        "value": radio.value,
        "checked": _vm._q(_vm.selectedItem, radio.value)
      },
      on: {
        "change": [function($event) {
          _vm.selectedItem = radio.value
        }, _vm.onChange]
      }
    }), _vm._v("\n\t\t\t\t\t\t" + _vm._s(radio.label) + "\n\t\t\t\t")])])
  }), _vm._v(" "), _vm._l((_vm.errors), function(error) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.length > 0),
        expression: "errors.length > 0"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(error))])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7db4a476!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/base/f-radio.vue
// module id = 666
// module chunks = 1